import React, { FC, memo } from "react";

export interface BgGlassmorphismProps {
  className?: string;
}

const BgGlassmorphismComponent: FC<BgGlassmorphismProps> = ({
  className = "absolute inset-x-0 top-0 min-h-0 pl-10 py-32 flex flex-col overflow-hidden z-0",
}) => {
  return (
    <div
      className={`nc-BgGlassmorphism ${className}`}
      data-nc-id="BgGlassmorphism"
    >
      <span className="bg-[#ef233c] w-80 h-80 rounded-full mix-blend-multiply filter blur-3xl opacity-20 lg:w-96 lg:h-96" />
      <span className="bg-[#04868b] w-80 h-80 ml-10 -mt-10 rounded-full mix-blend-multiply filter blur-3xl opacity-20 lg:w-96 lg:h-96 nc-animation-delay-2000" />
    </div>
  );
};

const BgGlassmorphism = memo(BgGlassmorphismComponent);

export default BgGlassmorphism;



